import { render } from "./MMessageItem.vue?vue&type=template&id=3fe27800"
import script from "./MMessageItem.vue?vue&type=script&lang=ts"
export * from "./MMessageItem.vue?vue&type=script&lang=ts"
script.render = render

export default script